import React from "react";
import Cover from "../../../ui/apps/library/book/cover";
import styled from "styled-components";
import { Button } from "@vitalsource/vstui";
import PropTypes from "prop-types";
import { styledMedia } from "../../components/mediaquery/breakpoints";

const Styled = {
  OuterContainer: styled.div`
    width: 100%;
    height: 75%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    ${styledMedia.tiny`
      height: 100%;
    `};
  `,
  InnerContainer: styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    ${styledMedia.tiny`
      flex-direction: column;
    `};
  `,
  CoverContainer: styled.div`
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    flex-grow: 0;
    flex-shrink: 0;
    order: 0;
  `,
  Header: styled.h1`
    font-size: 2rem;
    font-weight: 500;
    margin: 0 0 19px;
    color: ${p => p.theme.vstui.color.primary.getShade(6)};
    & > p {
      margin-bottom: 20px;
    }
  `,
  TextContent: styled.div`
    margin-left: 37px;
    font-size: 1.6rem;
    max-width: 210px;
    order: 1;
    ${styledMedia.tiny`
      margin-left: 0;
      margin-top: 37px;
    `};
  `
};

export default function Template({
  isbn,
  title,
  message,
  link,
  linkOnClick,
  assetTitle
}) {
  return (
    <Styled.OuterContainer>
      <Styled.InnerContainer>
        <Styled.TextContent>
          <Styled.Header>{title}</Styled.Header>
          <p>{message}</p>
          {link && (
            <Button inline onClick={linkOnClick}>
              {link}
            </Button>
          )}
        </Styled.TextContent>
        <Styled.CoverContainer>
          <Cover isbn={isbn} width={140} altText={assetTitle} />
        </Styled.CoverContainer>
      </Styled.InnerContainer>
    </Styled.OuterContainer>
  );
}

Template.propTypes = {
  isbn: PropTypes.string.isRequired,
  title: PropTypes.any.isRequired,
  message: PropTypes.any.isRequired,
  link: PropTypes.any,
  linkOnClick: PropTypes.func,
  assetTitle: PropTypes.string.isRequired
};
